export default {
  SET_STATUSES_ITINERARY_DATA(state, data) {
    state.status_itinerary = data;
  },
};
